/* ---------------------------------------------------- */
/* Updating Draw/Gui while keyUp                        */
/* ---------------------------------------------------- */

export default function onCodeEditorChange( instance ) {
	let stylesArea = window.Stylist.iDoc.getElementById( 'stlst-styles-area' )
	const cssDataFullBlock = window.Stylist.iDoc.getElementById( 'stlst-css-data-full' )

	if ( null === stylesArea ) {
		window.Stylist.iBody.insertAdjacentHTML( 'beforeend', "<div id='stlst-styles-area'></div>" )
		stylesArea = window.Stylist.iDoc.getElementById( 'stlst-styles-area' )
	}
	// Append all css to iframe.
	if ( null === cssDataFullBlock ) {
		stylesArea.insertAdjacentHTML( 'beforebegin', "<style id='stlst-css-data-full'></style>" )
	}

	const cssCode = window.Stylist.codeEditor.getValue()

	// Update css source.
	window.Stylist.iDocJQ.find( "#stlst-css-data-full" ).html( cssCode );

	// Prepare pseudo-classes replace.
	let cssCodeWithPseudoClasses = cssCode.replace( ':hover', '.stlst-hover' )
	cssCodeWithPseudoClasses = cssCodeWithPseudoClasses.replace( ':active', '.stlst-active' )
	cssCodeWithPseudoClasses = cssCodeWithPseudoClasses.replace( ':focus', '.stlst-focus' )

	// Update duplicate css code with :hover replaced by .stylist-hover
	// window.Stylist.iDoc.getElementById( 'stlst-css-data-pseudo-classes' ).innerHTML = cssCodeWithPseudoClasses

	// Empty the temporary styles data (#stlst-styles-area).
	stylesArea.innerHTML = ''

	// Remove temporary fast css rules (sliders colors).
	window.Stylist.iDocJQ.find( ".stlst-live-css" ).remove();

	/**
	 * On first editor load it will optimize and format existing CSS code
	 * using PostCSS. This action will create unwanted undo state and highlight
	 * 'Save' button. To fix it we will store this.state.initCssOptimization
	 * key to skip unwanted functions like codeChanged() and updateHistory()
	 * on the first run.
	 */

	if ( window.Stylist.isInitCssOptimized() ) {
		// Update state.codeChanged.
		window.Stylist.codeChanged()
		// Update undo/redo icons.
		window.Stylist.updateHistory()
	} else {
		// Update this.state.initCssOptimization = true:
		window.Stylist.setInitCssOptimized()
		// Reset editor history (undo/redo).
		window.Stylist.codeEditor.clearHistory()
	}
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/on-code-editor-change.js